// Supabase(PostgREST)·Postgres 오류 판정 한 곳 — 화면 여러 곳이 같은 기준으로 「옛 DB 로 물러나기」·「제한 시간」을 가른다(리뷰 59차 #5).

/**
 * 「그 칸이 없다」(마이그레이션 적용 전 DB)는 오류일 때만 true. PostgREST 는 없는 칸을 select·filter 하면
 * Postgres 오류 42703(undefined_column)을 돌려준다. 네트워크·시간 초과 같은 일시 오류에 폴백하면 새 칸이 빠진 채
 * 읽혀 보이는 값이 실제와 달라진다(🔒 보이는 비율 = 지급 비율, 2026-09-29 리뷰) — 그때는 폴백하지 않는다.
 */
// 화면은 읽기(select·filter)만 이 판정으로 물러난다 — 없는 칸을 읽으면 Postgres 가 42703 을 낸다. PGRST204(「could not find the … column」)는
// PostgREST 가 **쓰기 본문**의 칸을 스키마 캐시에서 못 찾을 때 내는 오류라 수집기(쓰기 · _shared/youtubeProbe.ts)만 본다.
// 화면 판정을 넓히면 🔴 배분율 lib(channelLicensedVideoShare 가 다시 내보냄)가 칸이 실제로 있는데도 옛 칸으로 물러날 수 있다(보이는 비율 ≠ 지급 비율 · 77차 #3)
export const isMissingColumnError = (error) => {
  if (!error) return false;
  if (String(error.code || '') === '42703') return true;
  return /column .+ does not exist/i.test(String(error.message || ''));
};

/** 문장 제한 시간(57014) — 되돌아가서 바뀐 것은 없다. 다시 눌러 볼 수 있다는 안내에 쓴다.
 *  글로는 「statement timeout」만 — 「canceling statement」는 잠금 대기 제한(55P03 · lock timeout)·사용자 취소에도 붙어 원인을 잘못 알렸다(107차 #2) */
export const isStatementTimeout = (error) => {
  if (!error) return false;
  // 57014(query_canceled)는 제한 시간과 취소(pg_cancel_backend · 사용자 요청)에 같이 쓰인다 — 글이 있으면 「statement timeout」일 때만(108차 #2)
  const msg = String(error.message || '');
  if (String(error.code || '') === '57014') return !msg || /statement timeout/i.test(msg);
  return /statement timeout/i.test(msg);
};

/**
 * 「그 함수가 없다」(마이그레이션 적용 전 DB) — PostgREST 가 함수 목록에서 못 찾을 때(PGRST202 · 「Could not find the function」)만.
 * 함수 **안에서** 난 42883(다른 함수·연산자 없음)은 배포된 함수의 고장이라 옛 질의로 숨기지 않는다(61차 #1 · Edge _shared/youtubeProbe.ts 와 같은 판정)
 */
export const isMissingFunctionError = (error) => {
  if (!error) return false;
  if (String(error.code || '') === 'PGRST202') return true;
  return /could not find the function/i.test(String(error.message || ''));
};

/**
 * 서버 함수가 **일시적으로** 실패했는가 — 제한 시간(57014) · 연결(08xxx) · 자원 부족(53xxx) · 관리자 종료(57P..) · 직렬화 충돌(40001·40P01) · 코드 없는 네트워크 오류.
 * 이때만 화면이 옛 표 읽기로 물러난다(82차 #3). 함수 안의 오류(42883 함수 없음 · 42P01 표 없음 등)는 고장이라 숨기지 않는다(61차 #1 · 83차 #1)
 */
export const isTransientRpcError = (error) => {
  if (!error) return false;
  if (isStatementTimeout(error)) return true;
  const code = String(error.code || '');
  // 코드 없는 오류는 **네트워크 실패**일 때만 — 프록시 오류 페이지·응답 해석 실패·CORS 같은 설정 고장은 숨기지 않는다(86차 #5)
  if (!code) return /failed to fetch|networkerror|network request failed|load failed|fetch failed|econn|etimedout|socket hang up/i.test(String(error.message || ''));
  // PGRST000~003 = PostgREST 의 DB 연결·연결 풀 오류(재시작·풀 고갈 — 가장 흔한 일시 오류 · 84차 #1)
  // 55P03 = 잠금 대기 제한(lock timeout) — 다른 쓰기가 끝나면 풀리는 일시 오류(107차 #2)
  // 57014 중 제한 시간이 아닌 것(취소)도 다시 해 볼 수 있는 일시 오류(108차 #2)
  return /^(08|53|57P)/.test(code) || code === '57014' || code === '40001' || code === '40P01' || code === '55P03' || /^PGRST00[0-3]$/.test(code);
};
